// extracted by mini-css-extract-plugin
export default {"r_l":"_03cba30e7f ed293be507","t":"_5fe3de9ad9"};